/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import { IconOk } from "../../icons/IconOk";
import "./style.css";

export const TestButton = ({
  endIcon = true,
  startIcon = true,
  label = "Label",
  type,
  size,
  disabled,
  onColor,
  className,
  textClassName,
}) => {
  return (
    <div
      className={`test-button ${type} on-color-${onColor} disabled-${disabled} size-${size} ${className}`}
    >
      {startIcon && (
        <IconOk
          className={`${type === "link" ? "class-3" : "class-4"}`}
          color={
            type === "primary" && disabled === "off"
              ? "white"
              : disabled === "on"
                ? "#8A8A8A"
                : (disabled === "off" &&
                      onColor === "off" &&
                      type === "secondary") ||
                    (disabled === "off" && type === "ghost") ||
                    (disabled === "off" && type === "link")
                  ? "#B5883E"
                  : onColor === "on"
                    ? "#F8F3EC"
                    : undefined
          }
        />
      )}

      <div className={`label ${textClassName}`}>
        {["ghost", "primary", "secondary"].includes(type) && <>{label}</>}

        {type === "link" && (
          <>
            <div className="label-wrapper">
              <div className="label-2">{label}</div>
            </div>

            <div className="line" />
          </>
        )}
      </div>

      {endIcon && (
        <IconOk
          className={`${type === "link" ? "class-3" : "class-4"}`}
          color={
            type === "primary" && disabled === "off"
              ? "white"
              : disabled === "on"
                ? "#8A8A8A"
                : (disabled === "off" &&
                      onColor === "off" &&
                      type === "secondary") ||
                    (disabled === "off" && type === "ghost") ||
                    (disabled === "off" && type === "link")
                  ? "#B5883E"
                  : onColor === "on"
                    ? "#F8F3EC"
                    : undefined
          }
        />
      )}
    </div>
  );
};

TestButton.propTypes = {
  endIcon: PropTypes.bool,
  startIcon: PropTypes.bool,
  label: PropTypes.string,
  type: PropTypes.oneOf(["primary", "link", "secondary", "ghost"]),
  size: PropTypes.oneOf(["large", "medium", "small"]),
  disabled: PropTypes.oneOf(["off", "on"]),
  onColor: PropTypes.oneOf(["off", "on"]),
};
